import React, { useEffect, useState } from 'react'
import frm from './formAux'
import $ from 'jquery';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import './datasetchatbot.css'

let global = null;
let gDataset = null;
let tmpResp = null;
let exportTid = null;
let promptCancel = false;
let promptCallback = null;


function runPrompt(promptVal) {
	return new Promise(async (resolve, reject) => {
		var nselected = 0;
		let dataset = gDataset;
		let param = 'Q&A';
		let recipeId = dataset.currentRecipes[param];
		let datasetId = dataset.datasetId;

		promptCancel = false;
		promptCallback = function(){
			runResult( {
				progress: 1,
				cancel: true,
			})
		}


		let input = $('#promptinput').val()
		// let det = responseObj(input, '<div class="custom-loader"></div>')

		let idx = promptVal.idx || responses.length;
		let promptObj = {
			promptIdx: idx,
			datasetId: datasetId,
			recipeId: recipeId,
			prompt: input,
			answer: '',
			source: [],
			state: 0,
			rate: 0,
			rateText: '',
			ts: Date.now(),
		}
		let det = responseObj( promptObj )
		// responses.push( promptObj );

		if (!window.GlobalVars.chatBots) window.GlobalVars.chatBots = {};
		window.GlobalVars.chatBots[gDataset.datasetId] = responses
		window.saveSession();

		tmpResp = det;
		let { data } = await window.post('find_recipe', { datasetId: gDataset.datasetId, recipeId: recipeId })
		let recipe = data.records && data.records[0] || null;
		if (!recipe) return frm.myAlert('Error', 'Invalid ' + param + ' recipe id' )
		console.log('RUNPROMPT', data)

		scrollTop();
		let exportProgress = null;

		async function runResult( data ) {
			if (data.progress == 1 ) {
				promptObj.promptId = data.promptId;
				if( data.cancel ) {
					promptObj.state = 2;
				}
				else if( !data.error ) {
					promptObj = { ...promptObj,
						answer: data.answer,
						state: 1,
						source: data.source || [], 
					}
				} 
				else {
					promptObj.state = 3;
					promptObj.error = data.error;
				}
				console.log('promptObj', JSON.stringify(promptObj,null,'\t'))
				responses.push( promptObj );
				tmpResp.remove();
				responseObj( promptObj );
				await window.saveSession();
				return resolve();
			}
		}

		async function recipeRun() {
			// alert( 'run')
			let { data } = await window.post('run_recipe', { recipeId: recipeId, datasetId: datasetId, promptText: promptVal, ts: promptObj.ts });
			console.log('recipeRun', data)
			runResult( data );
			// exportProgress.set(data.progress)
			if (!promptCancel && data.progress != 1) exportTid = setTimeout(recipeRun, 2000 );
		}
		recipeRun();
	});
}

async function ratePrompt( idx, v ) {
	let div = $('.prompt_'+idx );
	console.log( 'ratePrompt', idx, v, responses[idx].promptId );
	let r = responses[idx];
	console.log('RES Like', r)
	div.find('.promptrate').removeClass('prompt-rate-select');
	if( r.rate == v ) r.rate = 0;
	else {
		if( v == -1 ) {
			let reason = await frm.myInput( 'Negative rating', 'Enter reason for the negative rating', r.rateText, 'Negative rating' )
			if( reason === null ) return;
			r.rateText = reason;
		}
		else r.rateText = '';
		r.rate = v;
	}
	window.post( 'recipe_prompt_feedback', {prompt: r } )
	if( r.rate == -1 ) div.find('.promptratedown').addClass('prompt-rate-select')
	else if( r.rate == 1 ) div.find('.promptrateup').addClass('prompt-rate-select')
	window.saveSession();
}

let regButtons = [
	{
		id: 'rateup',
		text: '<i class="fa fa-thumbs-up"></i>',
		title: 'Rate answer as good',
		class: 'promptrate promptrateup',
		callback: function () {
			let promptIdx = $(this).closest( '.prompt_response' ).attr('idx')
			ratePrompt( promptIdx, 1 );
		},
	},
	{
		id: 'ratedown',
		text: '<i class="fa fa-thumbs-down"></i>',
		title: 'Rate answer as bad',
		class: 'promptrate promptratedown',
		callback: function () {
			let promptIdx = $(this).closest( '.prompt_response' ).attr('idx')
			ratePrompt( promptIdx, -1 );
		},
	},	
	{
		id: 'copy',
		text: '<i class="fa fa-copy"></i> Copy response',
		title: 'Copy Response',
		callback: function () {
			let txt = $(this).closest('.prompt_response').find('.response_details')[0].innerText
			frm.saveClipboard(txt)
			let tid = setTimeout(function () { frm.myAlertClose() }, 2000);
			frm.myAlert('Response Copied', txt, 'Ok', function () {
				clearTimeout(tid);
			});
		},
	},
	{
		id: 'reuse',
		text: '<i class="fa fa-refresh"></i> Reuse prompt',
		title: 'Reuse prompt',
		callback: function () {
			let txt = $(this).closest('.prompt_response').find('summary')[0].innerText
			$("#promptinput").val(txt)[0].focus();
			scrollTop()
		},
	}
]

function scrollTop() {
	setTimeout( function(){
		$('.prompt_results').scrollTop(1000000);
	}, 100 )	
}

function responseObj( r ) {
	let title = r.prompt;

	let div = $('<details class="prompt_response untouched prompt_'+r.promptIdx+'" open="" idx="'+ r.promptIdx +'"><summary>' + title + '</summary><div class="prompt_buttons"></div><div class="response_details"></div></details>').on('click', function () {
		// console.log(this)
		$(this).removeClass('untouched')
	})

	let details = div.find('.response_details');
	details.html('');
	let defaultBtns = [];
	for( let b of regButtons ) defaultBtns.push( {...b} );
	if( r.state == 1 ) {
		details.append( $('<p>'+r.answer+'</p>'))
		if( r.rate == 1 ) {
			defaultBtns.find( b => b.id == 'rateup' ).class += ' prompt-rate-select';
		}
		else if( r.rate == -1 ) defaultBtns.find( b => b.id == 'ratedown' ).class += ' prompt-rate-select';
		if( r.source && r.source.length ) {
			details.append( '<br><b>References:</b>');
			let ul = $('<ul>');
			for( let s of r.source ) {
				if( !s.ok ) continue;
				let li = $('<li>').attr('item_id', s.item_id).attr('page_num', s.page_num || '');
				let aa = $('<A target="_blank">').attr('href', s.link || '');
				aa.append( $('<span>').html( s.name ) );
				if( s.page_num ) aa.append( $('<span>').html( ' - Page ' + s.page_num ) );
				if( s.text ) aa.append( $('<div class="prompt-source-text">').html( s.text ) );
				aa.find('.prompt-source-text').attr('title', s.text );
				li.append(aa);
				ul.append(li);
			}
			details.append( ul );
		}
		setButtons( div, defaultBtns );
	}
	else if( r.state == 0 ) {
		details.append( $('<div class="custom-loader"></div>'))
		setButtons( div, [
			{
				id: 'cancel',
				text: '<i class="fa fa-stop-circle-o"></i> Cancel query',
				class: 'prompt-cancel',
				callback: function () {
					clearTimeout( exportTid );
					promptCancel = true;
					if( promptCallback ) promptCallback();
				},
			}
		])
	}
	else if( r.state == 2 ) {

		details.append( $('<p>(canceled)</p>') );
		defaultBtns = defaultBtns.filter( b => b.id == 'reuse' )
		setButtons( div, defaultBtns )
	}
	else if( r.state == 3 ) {
		let etxt = '<p class="prompt-error">ERROR</p>';
		if( r.error ) etxt = '<p class="prompt-error">ERROR: '+r.error+'</p>';
		details.append($(etxt));
		defaultBtns = defaultBtns.filter( b => b.id == 'reuse' )
		setButtons( div, defaultBtns )
	}
	// tmpResp.find('.prompt-source-text').attr('title', s.text )

	$('.prompt_results').append( div )
	return div;
}

function setButtons( resp, btns ) {
	let dbut = resp.find('.prompt_buttons');
	dbut.html('')
	for( let b in btns ) {
		let btn = $('<button>').addClass( 'btn btn-secondary').html(btns[b].text ).on('click', btns[b].callback );
		if( btns[b].title ) btn.attr('title', btns[b].title )
		// console.log( 'BBBBB', b )
		if( btns[b].css ) btn.css( btns[b].css )
		if( btns[b].class ) btn.addClass( btns[b].class )
		dbut.append(btn)
	}
}

let init = false;
let responses = [];



const DatasetChatBot = () => {

	const [promptInput, setPromptInput] = useState("");
	const [promptResponse, setPromptResponse] = useState([]);


	// const [inited,init] = useState('init');

	let handlePromptInput = async (e) => {
		// $('.untouched').attr('open', false)
		let input = $('#promptinput').val()
		// frm.loading('querying')
		$("#promptinput").attr('disabled',true)
		$('#buttonsend').attr('disabled',true)
		let resp = await runPrompt(input);
		$("#promptinput").attr('disabled',false)
		$('#buttonsend').attr('disabled',false)
		// alert( aaa )

		$("#promptinput").val('')
		scrollTop();
	}

	useEffect(v => {
		if (!init) {
			global = window.GlobalVars;
			gDataset = global.currentDataset;

			init = true;
			responses = ((global.chatBots || {})[gDataset.datasetId]) || [];
			let lastr = null;
			$('.prompt_results').html('')
			for( let v of responses ) {
				// let [input,resp,open] = v;
				let det = lastr = responseObj( v )
			}
			if( lastr ) lastr.attr('open', true );
			$("#promptinput").on('keyup', (ev) => {
				if (ev.key == 'Enter') handlePromptInput();
			})
			$("#promptinput")[0].focus()
			scrollTop();
		}
	})

	return (
		<div className='chatbot_container'>
			<div fluid="md p-0" className="maincontent prompt_results">
				{/* {
					promptResponse.map((prompt, index) => (
						<details className="prompt_response">
							<summary>{prompt.title}</summary>
							<div className='response_details'>
								<h6>{prompt.query}</h6>
								<p>{prompt.result}</p>
							</div>
						</details>
					))
				} */}
			</div>
			<div className='prompt_input bg-white'>
				<div className='m-auto col-7 d-flex justify-content-center align-items-center'>
					<Form.Control className="chatinput p-3" placeholder="Enter prompt here" type="text" id="promptinput" value={promptInput} onChange={(e) => setPromptInput(e.target.value)} />
					<Button id="buttonsend" variant="primary" className="ml-2" onClick={() => handlePromptInput()}>Send</Button>
				</div>
			</div>
		</div>
	)
}

export default DatasetChatBot